import React from 'react'
import { RunType } from '../../types'

interface RunTypeBadgeProps {
  runType: RunType
}

export const RunTypeBadge: React.FC<RunTypeBadgeProps> = ({ runType }) => {
  return <span className="eval-type-badge">{runType}</span>
}
